import React from "react";
import { Route, Routes } from "react-router-dom";

import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/style.scss";
import "./assets/scss/bootstrap.scss";
import "./assets/css/materialdesignicons.min.css";

import Home from "./pages/index/index-three";
import About from "./pages/dms_mutt/About";
import Events from "./pages/others/events";
import EventDetails from "./pages/others/eventDetails";
import GalleryPhotos from "./pages/others/gallery-photo";
import PhotoList from "./pages/others/photo-list";
import GalleryVideo from "./pages/others/gallery-video";
import VideoList from "./pages/others/video-list";
import Blogs from "./pages/others/blogs";
import BlogDetail from "./pages/others/blog-detail";
import Media from "./pages/others/media";
import MediaList from "./pages/others/media-list";
import MediaDeatils from "./pages/others/media-details";
import Donations from "./pages/others/donations";
import Contact from "./pages/others/contact";
import Error from "./pages/others/error";
import Contactform from "./components/form/Index";

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/events" element={<Events />} />
      <Route path="/event-details/:id" element={<EventDetails />} />
      <Route path="/gallery-photos" element={<GalleryPhotos />} />
      <Route path="/photo-list/:id" element={<PhotoList />} />
      <Route path="/gallery-videos" element={<GalleryVideo />} />
      <Route path="/videos-list/:id" element={<VideoList />} />
      <Route path="/blogs" element={<Blogs />} />
      <Route path="/blog-detail/:id" element={<BlogDetail />} />
      <Route path="/media" element={<Media />} />
      <Route path="/media-list/:id" element={<MediaList />} />
      <Route path="/media-details/:id" element={<MediaDeatils />} />
      <Route path="/donations" element={<Donations />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/contact-form" element={<Contactform />} />
      <Route path="/error" element={<Error />} />
      <Route path="*" element={<Error />} />
    </Routes>
  );
}

export default App;
